<template>
  <div class="avatar-menu">
    <el-dropdown @command="userOpt" trigger="click">
      <el-avatar icon="el-icon-user-solid" class="avatar-img" :size="35" :src="avatar"></el-avatar>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="quite">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    name: "AvatarMenu",
    data() {
      return {
        avatar: "",
      }
    },
    methods: {
      userOpt(command) {
        if (command === "quite") {
          this.quite();
        }
      },
      // 注销
      quite() {
        this.openConfirm('退出登录', async () => {
          let res = await this.$Http.logout();
          if (res) {
            this.$router.push({name: "login", params: {isLogout: "1"}}).catch(() => {});
            this.msgSuccess('操作成功！');
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .avatar-menu {
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    .avatar-img:hover {
      background-color: #fff;
      color: #C0C4CC;
    }
    .el-dropdown {
      font-size: 0;
    }
  }
</style>
